const settings = [
  { label: 't(Accouting Platform)', name: 'integration', type: 'dropdown', options: [
    { value: 'accpac', text: 't(ACCPAC)' },
    { value: 'accumatica', text: 't(Accumatica)' }
  ], valueKey: 'value', textKey: 'text' },
  { label: 't(Invoice Address)', name: 'address', type: 'textarea', rows: 2 }
]

export default settings
